import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import cssModule from 'react-css-modules';
import PropTypes from 'prop-types';

import { getMatchTeams } from 'reducers/index';
import DefaultSeparator from '../../../defaultSeparator/DefaultSeparator';
import styles from './TennisDouble.scss';
import Ranking from '../components/ranking/Ranking';
import TennisFlags from '../components/tennisFlags/TennisFlags';

const mapStateToProps = ((state, ownProps) => ({
  teams: getMatchTeams(state, ownProps.matchId),
}));

const TennisDouble = ({
  matchId, competitors, teams,
}) => {
  const homeTeamArray = competitors && competitors.home && competitors.home[0] && competitors.home[0].name
    ? competitors.home[0].name.split('/')
    : ['', ''];
  const awayTeamArray = competitors && competitors.away && competitors.away[0] && competitors.away[0].name
    ? competitors.away[0].name.split('/')
    : ['', ''];

  /*
   Logic to handle the case, when second competitor is not defined even though it is a double match.
   Create a copy of the teams to avoid mutating the original object.
  */
  const homeTeam = [...teams.home];
  const awayTeam = [...teams.away];

  if (!homeTeam[1]) {
    homeTeam.push({
      countryCodeA2: '', name: '', mediumname: '', uniqueId: '',
    });
  }

  if (!awayTeam[1]) {
    awayTeam.push({
      countryCodeA2: '', name: '', mediumname: '', uniqueId: '',
    });
  }

  return (
    <Fragment>
      <div className={'z-10 mb-8 fs-16 flex justify-center items-start w-full'}>
        <div styleName='double_flags' className={'flex justify-center items-center flex-col w-2/5'}>
          <TennisFlags teams={homeTeam} />
          <h2 className={'font-main--bold uppercase items-center text-center flex'}>{homeTeamArray[0]}</h2>
          <h2 className={'font-main--bold uppercase items-center text-center flex'}>{homeTeamArray[1]}</h2>
        </div>
        <div className={'flex flex-col justify-center items-center w-1/5 h-full'}>
          <DefaultSeparator />
        </div>
        <div styleName='double_flags' className={'flex justify-center items-center flex-col w-2/5'}>
          <TennisFlags teams={awayTeam} />
          <h2 className={'font-main--bold uppercase items-center text-center flex'}>{awayTeamArray[0]}</h2>
          <h2 className={'font-main--bold uppercase items-center text-center flex'}>{awayTeamArray[1]}</h2>
        </div>
      </div>
      <Ranking matchId={matchId} />
    </Fragment>
  );
};

TennisDouble.propTypes = {
  matchId: PropTypes.number.isRequired,
  competitors: PropTypes.object.isRequired,
  teams: PropTypes.shape({
    home: PropTypes.array,
    away: PropTypes.array,
  }),
};

TennisDouble.defaultProps = {
  teams: {
    home: [{ name: '', abbr: '' }],
    away: [{ name: '', abbr: '' }],
  },
};

const TennisDoubleStyled = cssModule(TennisDouble, styles);
export default connect(mapStateToProps)(TennisDoubleStyled);
